import { render, staticRenderFns } from "./IconPin.vue?vue&type=template&id=271be05e"
import script from "./IconPin.vue?vue&type=script&lang=js"
export * from "./IconPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports